import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { AdminRoute, StudentRoute } from "@/components/ProtectedRoute";
import AdminLayout from "@/components/AdminLayout";
import GlobalLoader from "@/components/GlobalLoader";
import Login from "@/pages/Login";
import StudentLogin from "@/pages/StudentLogin";
import StudentRegister from "@/pages/StudentRegister";
import Dashboard from "@/pages/Dashboard";
import Students from "@/pages/Students";
import StudentNew from "@/pages/StudentNew";
import StudentDetail from "@/pages/StudentDetail";
import Fees from "@/pages/Fees";
import Reminders from "@/pages/Reminders";
import Programs from "@/pages/Programs";
import Staff from "@/pages/Staff";
import Expenses from "@/pages/Expenses";
import StudentPortal from "@/pages/StudentPortal";

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <GlobalLoader />
        <Routes>
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="/login" element={<Login />} />
          <Route path="/student-login" element={<StudentLogin />} />
          <Route path="/register" element={<StudentRegister />} />

          <Route element={<AdminRoute><AdminLayout /></AdminRoute>}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/students" element={<Students />} />
            <Route path="/students/new" element={<StudentNew />} />
            <Route path="/students/:id" element={<StudentDetail />} />
            <Route path="/fees" element={<Fees />} />
            <Route path="/reminders" element={<Reminders />} />
            <Route path="/programs" element={<Programs />} />
            <Route path="/expenses" element={<Expenses />} />
            <Route path="/staff" element={<Staff />} />
          </Route>

          <Route path="/portal" element={<StudentRoute><StudentPortal /></StudentRoute>} />

          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
